export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9127.94dbe3a1.jpg";